import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DigitalNav.scss';

const LANGUAGES = [
    { code: 'fr', label: 'FR' },
    { code: 'en', label: 'EN' },
    { code: 'ar', label: 'AR' },
    { code: 'es', label: 'ES' },
];

const DigitalNav = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);


    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 0);
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => { setMenuOpen(false); }, [location]);

    const changeLanguage = (code) => {
        i18n.changeLanguage(code);
        document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
    };

    const isActive = (path) => location.pathname === path;

    return (
        <nav className={`dn-nav ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>


            <div className="dn-nav-inner">
                <Link to="/" className="dn-logo">KANEM</Link>

                <div className={`dn-links ${menuOpen ? 'open' : ''}`}>
                    <Link to="/" className={isActive('/') ? 'active' : ''}>{t('nav.home')}</Link>
                    {/* Desktop only */}
                    <Link
                        to="/"
                        className="dn-desktop-only"
                        onClick={(e) => {
                            if (isActive('/')) {
                                e.preventDefault();
                                document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                            }
                            setMenuOpen(false);
                        }}
                    >
                        {t('nav.services')}
                    </Link>



                    {/* Mobile only */}
                    <Link to="/services/creation-site-web" className="dn-mobile-only" onClick={() => setMenuOpen(false)}>{t('services.web.title')}</Link>
                    <Link to="/services/reseaux-sociaux" className="dn-mobile-only" onClick={() => setMenuOpen(false)}>{t('services.social.title')}</Link>
                    <Link to="/solutions/automatisation" className="dn-mobile-only" onClick={() => setMenuOpen(false)}>{t('digital.services.2.title')}</Link>

                    <Link to="/a-propos" className={isActive('/a-propos') ? 'active' : ''} onClick={() => setMenuOpen(false)}>{t('nav.about')}</Link>
                    <Link to="/contact" className={`dn-cta ${isActive('/contact') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>{t('nav.contact')}</Link>
                </div>



                <div className="dn-right">
                    <div className="dn-lang">
                        {LANGUAGES.map(lang => (
                            <button
                                key={lang.code}
                                className={i18n.language === lang.code ? 'active' : ''}
                                onClick={() => changeLanguage(lang.code)}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                    <button
                        className={`dn-hamburger ${menuOpen ? 'open' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span /><span /><span />
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default DigitalNav;
